<template>
  <div class="row m-0 new-tabs-section">
    <div class="col-6 p-0">
      <div 
        class="tab-item tab-cases d-flex align-items-center justify-content-center" 
        :class="{ 'active': activeMode === 'patients', 'no-pointer': isHomePage && activeMode === 'patients' }"
        @click="handleModeClick('patients')"
      >
         <div class="inner-tab-content">
            <span class="tab-text fw-bold">الحالات العلاجية</span>
            <img v-if="activeMode === 'patients'" src="@/assets/icons/tab-cases-active.svg" alt="cases" class="tab-icon"/>
            <img v-else src="@/assets/icons/tab-cases-non-active.svg" alt="cases" class="tab-icon"/>
         </div>
      </div>
    </div>
    <div class="col-6 p-0">
      <div 
        class="tab-item tab-awqaf d-flex align-items-center justify-content-center"
        :class="{ 'active': activeMode === 'endowments', 'no-pointer': isHomePage && activeMode === 'endowments' }"
        @click="handleModeClick('endowments')"
      >
         <div class="inner-tab-content">
            <span class="tab-text fw-bold">الأوقاف والصناديق</span>
             <img v-if="activeMode === 'endowments'" src="@/assets/icons/tab-awqaf-active.svg" alt="awqaf" class="tab-icon"/>
             <img v-else src="@/assets/icons/tab-awqaf-non-active.svg" alt="awqaf" class="tab-icon"/>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DonationTypeTabs",
  data() {
    return {
      activeMode: 'patients'
    };
  },
  computed: {
    isHomePage() {
      return this.$route.path === '/home' || this.$route.path === '/';
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.query.mode) {
           const mode = to.query.mode === 'cases' ? 'patients' : to.query.mode;
           this.activeMode = mode;
           localStorage.setItem('donation_mode', mode);
        } else {
           const savedMode = localStorage.getItem('donation_mode');
           if (savedMode) {
             this.activeMode = savedMode;
             const baseUrl = window.location.origin;
             const newUrl = new URL(`${baseUrl}/home`);
             let queryMode = savedMode;
             if (savedMode === 'patients') queryMode = 'cases';
             newUrl.searchParams.set('mode', queryMode);
             window.history.replaceState({}, '', newUrl.toString());
           } else {
             this.activeMode = 'patients';
           }
        }
      }
    }
  },
  methods: {
    handleModeClick(mode) {
      if (this.isHomePage && this.activeMode === mode) {
        return;
      }
      
      this.activeMode = mode;
      localStorage.setItem('donation_mode', mode);
      
      const baseUrl = window.location.origin;
      const newUrl = new URL(`${baseUrl}/home`);
      
      let queryMode = mode;
      if (mode === 'patients') queryMode = 'cases';
      
      newUrl.searchParams.set('mode', queryMode);
      
      window.location.href = newUrl.toString();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/abstracts/mixins";

.new-tabs-section {
  margin-top: -10px !important;
  position: relative;
  z-index: 1; 
  .tab-item {
    height: 100px;
    font-size: 24px;
    transition: color 0.2s ease, background-color 0.2s ease;
    background-color: $color-tab-awqaf;
    cursor: pointer;
    
    &.no-pointer {
      cursor: default !important;
    }
    
    .tab-text {
      color: $color-font-dark;
    }
    
    &.tab-cases {
       &.active {
          background: linear-gradient(90deg, $color-tab-cases-end 0%, $color-tab-cases-start 100%) !important;
          .tab-text {
            color: $color-white;
          }
       }
    }
    
    &.tab-awqaf {
       &.active {
          background: linear-gradient(90deg, $color-tab-cases-start 0%, $color-tab-awqaf-active-end 100%) !important;
          .tab-text {
             color: $color-white;
          }
       }
    }

    &:not(.active):hover {
      background-color: $color-tab-hover;
    }

    .tab-icon {
      width: 60px;
      height: 60px;
    }

    .inner-tab-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 60%;

      @include respond("md") {
        width: 80%;
      }
      @include respond("sm") {
        width: 90%;
      }
    }
  }


  @include respond("xl") {
    margin-top: -25px !important;
  }

  @include respond("md") {
    .tab-item {
      height: 70px;
      font-size: 16px;
      .tab-icon {
        width: 35px;
        height: 35px;
      }
    }
  }

  @include respond("sm") {
    .tab-item {
      height: 60px;
      font-size: 14px;
       .tab-icon {
          width: 30px;
          height: 30px;
       }
    }
  }
}
</style>
